import {
  OPEN_MEETINGROOM_MODAL,
  CLOSE_MEETINGROOM_MODAL,
  OPEN_ROOMSELECT_POPUP_MODAL,
  CLOSE_ROOMSELECT_POPUP_MODAL,
  TERMS_CONDITIONS_INIT,
} from '../constants';

export default function common(
  state = {
    link: null,
    openMeetingRoomModal: false,
    openRoomSelectPopupModal: false,
    dataPopup: {},
    termsConditions: null,
  },
  action,
) {
  switch (action.type) {
    case OPEN_MEETINGROOM_MODAL: {
      return {
        ...state,
        openMeetingRoomModal: true,
        link: action.payload,
      };
    }
    case CLOSE_MEETINGROOM_MODAL: {
      return {
        ...state,
        openMeetingRoomModal: false,
        link: null,
      };
    }
    case OPEN_ROOMSELECT_POPUP_MODAL: {
      return {
        ...state,
        openRoomSelectPopupModal: true,
        dataPopup: action.dataPopup,
      };
    }
    case CLOSE_ROOMSELECT_POPUP_MODAL: {
      return {
        ...state,
        openRoomSelectPopupModal: false,
      };
    }
    case TERMS_CONDITIONS_INIT: {
      return {
        ...state,
        termsConditions: action.payload,
      };
    }
    default:
      return state;
  }
}
